<div class="avatar-container">
    <finder-picture [@animateAvatar]="animateAvatar" class="image circle" [picture]="avatar"></finder-picture>
    <div class="avatar-details" data-cs-mask>
        <p class="title">{{ title }}</p>
        <p *ngIf="subtitle">{{ subtitle }}</p>
        <p *ngIf="detail && !guest?.disabled">{{ detail }}</p>
        <p *ngIf="guest?.disabled"><i><strong>{{ guest.labels.pendingMerge }}</strong></i></p>
        <p *ngIf="guest?.primaryMerge" class="status">{{ guest.labels.profileManagedByYou }}</p>
        <p *ngIf="guest?.disabled"
            class="status"> {{guest.labels.profileManagedBy}} {{guest.manager.firstName}} {{guest.manager.lastName}}</p>
    </div>
</div>
